import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=7b528015&scoped=true&"
import script from "./Cooperate.vue?vue&type=script&lang=js&"
export * from "./Cooperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b528015",
  null
  
)

export default component.exports